import { MenuItem, TextField } from '@mui/material';
import { Btn } from '../Conteiner';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { DivCadastro, FormCadastro, ModalTech } from './styles';
import { useContext } from 'react';
import { UserContexts , ITech } from '../../Context/UserContexts';


function ModalNovasTech() {
  const { addTech,  handleClose} = useContext(UserContexts);


    const formSchema = yup.object().shape({
        title: yup.string().required('Nome obrigatório').min(3, 'Deve ter mais de 3 caracteres'),
        status: yup.string().required('Selecione um estatus')
      });
  
    const { register, handleSubmit, formState:{ errors } } = useForm<ITech>({
      resolver:yupResolver(formSchema)
    })





  return (

    <ModalTech >
        <DivCadastro >
          <div className='HeaderCadastro'>
              <h3>Cadastras tecnologias</h3>
              <button onClick={()=>handleClose()}>X</button>
          </div>
          <div className='ConteinerFormCadastro'>
              <FormCadastro onSubmit={handleSubmit(addTech)}>
              <TextField required error={ !!errors.title} placeholder="Digite sua tecnologia"
                  helperText={errors?.title?.message} label="title"  
                  {...register("title")}>
                  </TextField>
                  <TextField  className='inputSelectModule' label='Selecionar estatus' select 
                  required error={!!errors.status} helperText={errors?.status?.message}
                  {...register("status")}>
                      <MenuItem key="Iniciante" value="Inicialnte">
                      {`Iniciante`}
                      </MenuItem>
                      <MenuItem key="Intermediário" value="Intermediario">
                      {`Intermediario`}
                      </MenuItem>            
                      <MenuItem key="Avançado" value="Avançado">
                      {`Avançado`}
                      </MenuItem>
                  </TextField>
                  <Btn color={`#FF577F`} type='submit'>Cadastrar tecnologia</Btn>
              </FormCadastro>
          </div>
        </DivCadastro>
    </ModalTech>

  );

}

export default ModalNovasTech;